import { Component, OnInit, Inject, SimpleChanges } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ErrorReportService } from '../../../tvf/errors-manager/services/errors.service';
import { ToastrService } from 'ngx-toastr';
import { TvfRequestsService } from '@app/tvf/services/tvf-requests.service';
interface HistoricoItem {
  usuario: string;
  data: string;
  alteracoes: string[];
}
@Component({
  selector: 'app-modal-history-trade-details',
  templateUrl: './modal-history-trade-details.component.html',
  styleUrls: ['./modal-history-trade-details.component.sass'],
})
export class ModalHistoryTradeDetailsComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalHistoryTradeDetailsComponent>,
    private toastr: ToastrService,
    private tvfRequestsService: TvfRequestsService
  ) {}
  historico: any[] = [];
  notData: boolean = false;
  ngOnInit(): void {
    this.getHistory();
  }

  getHistory() {
    const idTrade = this.data.idTrade;

    this.tvfRequestsService.getHistoryDetailsTrade(idTrade).subscribe({
      next: (response) => {
        const history = response.history || [];
        const current = response.current;

        const historicoFormatado = history.map((item: any) => ({
          usuario: item.updatedBy,
          data: item.createdAt ? new Date(item.createdAt).toLocaleString() : '',
          alteracoes: this.getAlteracoes(item),
        }));

        if (current) {
          historicoFormatado.unshift({
            usuario: current.updatedBy,
            data: 'Atual',
            alteracoes: this.getAlteracoes(current),
          });
        }

        this.historico = historicoFormatado;
        this.notData = this.historico.length === 0;
      },
      error: (response) => {
        const errorMsg = response.errors?.[0] ?? 'Erro ao buscar histórico.';
        this.toastr.error(errorMsg);
      },
    });
  }

  getAlteracoes(item: any): string[] {
    const alteracoes: string[] = [];

    if (item.carrierPlot) {
      alteracoes.push(`O portador foi alterado para ${item.carrierPlot.join(', ')}`);
    }

    if (item.agencyCarrierPlot) {
      alteracoes.push(`A agência foi alterada para ${item.agencyCarrierPlot.join(', ')}`);
    }

        if (item.cashflowInstallment) {
      alteracoes.push(`O Fluxo de Caixa foi alterado para ${item.cashflowInstallment.join(', ')}`);
    }

    return alteracoes;
  }

  close() {
    this.dialogRef.close();
  }
}
